// extracted by mini-css-extract-plugin
module.exports = {"back-button-header":"back-button-header__55axL","back-button-text":"back-button-text__1HvaT"};